import React, {Component} from 'react';

const formatVagas = (garage) => {
    if (garage === null || garage === undefined || garage === '' || garage === 0 || garage === '0') {
        return '0 Vagas';
    }

    const valor = String(garage);

    if (valor.includes('Vagas Descobertas') || valor.includes('Vaga Descoberta') || valor.includes('Vaga Rotativa')) {
        return valor;
    }

    return valor === '1' ? `${valor} Vaga Coberta` : `${valor} Vagas Cobertas`;
};

const tableStyles = {
    wrapper: {
        marginBottom: '54px',
    },
    label: {
        fontFamily: "'Archivo Expanded', 'Archivo', sans-serif",
        fontWeight: 400,
        fontSize: '19px',
        color: '#5B595B',
        marginBottom: '12px',
        display: 'block',
    },
    table: {
        width: 'auto',
        borderCollapse: 'collapse',
        border: 'none',
        marginBottom: '30px',
    },
    th: {
        fontFamily: "'Archivo Expanded', 'Archivo', sans-serif",
        fontWeight: 700,
        fontSize: '23px',
        color: '#5B595B',
        textAlign: 'center',
        padding: '10px 24px',
        border: 'none',
        backgroundColor: 'transparent',
    },
    tdOdd: {
        fontFamily: "'Archivo Expanded', 'Archivo', sans-serif",
        fontWeight: 400,
        fontSize: '19px',
        color: '#5B595B',
        textAlign: 'center',
        padding: '8px 24px',
        border: '1px solid #BCBEC0',
        backgroundColor: '#EEEFF0',
    },
    tdEven: {
        fontFamily: "'Archivo Expanded', 'Archivo', sans-serif",
        fontWeight: 400,
        fontSize: '19px',
        color: '#5B595B',
        textAlign: 'center',
        padding: '8px 24px',
        border: '1px solid #BCBEC0',
        backgroundColor: '#FFFFFF',
    },
};

class EstoqueValoresTable extends Component {

    render() {
        const showValor   = this.props.observacao === 'Valor incorreto' || this.props.observacao === 'Preço';
        const showEstoque = this.props.observacao === 'Estoque incorreto' || this.props.observacao === 'Estoque';
        const showInfo    = this.props.observacao === 'Tipologia' || this.props.observacao === 'Ficha técnica';

        const labelText = showInfo
            ? 'Informações do empreendimento'
            : showValor
                ? 'Valor informado pelo cliente'
                : 'Estoque informado pelo cliente';

        return (
            <div style={tableStyles.wrapper}>
                <span style={tableStyles.label}>{labelText}</span>
                <table style={tableStyles.table}>
                    <thead>
                        <tr>
                            <th style={tableStyles.th}>Área privativa</th>
                            <th style={tableStyles.th}>Tipologia</th>
                            <th style={tableStyles.th}>Dormitórios</th>
                            {showInfo && <th style={tableStyles.th}>Vagas</th>}
                            <th style={tableStyles.th}>Unidades</th>
                            {showValor   && <th style={tableStyles.th}>Preço</th>}
                            {showEstoque && <th style={tableStyles.th}>Estoque</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.tipologias.map((tipologia, index) => {
                            const tdStyle = index % 2 === 0 ? tableStyles.tdOdd : tableStyles.tdEven;
                            return (
                                <tr key={tipologia.id}>
                                    <td style={tdStyle}>{tipologia.private_area}</td>
                                    <td style={tdStyle}>{tipologia.type_of_typology}</td>
                                    <td style={tdStyle}>{tipologia.number_bedroom}</td>
                                    {showInfo && <td style={tdStyle}>{formatVagas(tipologia.garage)}</td>}
                                    <td style={tdStyle}>{tipologia.qty}</td>
                                    {showValor   && <td style={tdStyle}>{tipologia.valor}</td>}
                                    {showEstoque && <td style={tdStyle}>{tipologia.estoque}</td>}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }

}

export default EstoqueValoresTable;
